import { applyFilters, doRequest } from "./helpers";

const MxDomainService = {
  getTable: (filters = {}) => {
    return doRequest("GET", applyFilters(filters, "/mx_domains/"));
  },

  revalidateAll: () => {
    return doRequest("POST", "/mx_domains/revalidate");
  },

  revalidate: id => {
    return doRequest("POST", `/mx_domains/${id}/revalidate`);
  },
};

export default MxDomainService;
